import type {
  IOpportunityMSDocument,
  IOpportunityMSUploadDocument,
} from './../types/document/models'
import { makeDocumentService } from '~/cynqueModules/factoriesForServices/documents'

export const {
  createDocument: createOpportunityMSDocument,
  updateDocument: updateOpportunityMSDocument,
  deleteDocument: deleteOpportunityMSDocument,
} = makeDocumentService<IOpportunityMSDocument, IOpportunityMSUploadDocument>(
  '/api/opportunitymsdocuments',
  'opportunityMSDocument'
)
